var map = {
	"./AI.svg": "21be",
	"./AI1.svg": "7e98",
	"./AI2.svg": "359b",
	"./AI3.svg": "c853",
	"./AI4.svg": "78d8",
	"./AI5.svg": "31c1",
	"./AI6.svg": "50a5",
	"./Battery.svg": "fe2b",
	"./NoDataAvailable.svg": "8885",
	"./NormalSafety.svg": "280d",
	"./Power.svg": "f05b",
	"./Someone.svg": "bb84",
	"./Stratosphere.svg": "854f",
	"./amplification.svg": "8728",
	"./asset.svg": "b538",
	"./assets.svg": "db03",
	"./audit.svg": "d393",
	"./authorization.svg": "f6b5",
	"./bigscreen.svg": "e6ee",
	"./bike.svg": "70be",
	"./bind.svg": "b572",
	"./camera.svg": "8ce0",
	"./click.svg": "6079",
	"./community_elevator.svg": "b864",
	"./console.svg": "f55a",
	"./data.svg": "5a0a",
	"./department.svg": "0060",
	"./device (1).svg": "502c",
	"./device.svg": "2c87",
	"./dictionaries.svg": "7a06",
	"./dsmg.svg": "594d",
	"./elevator (1).svg": "b2e3",
	"./elevator.svg": "c782",
	"./elevator_monitor.svg": "232b",
	"./elevator_page_monitor.svg": "1ad6",
	"./encourage.svg": "76ed",
	"./error.svg": "b1b9",
	"./fault.svg": "6701",
	"./faultCensus.svg": "c806",
	"./faultExamine.svg": "cfb5",
	"./faultManage.svg": "f78e",
	"./fault_1.svg": "9314",
	"./file.svg": "b8b2",
	"./filter.svg": "c886",
	"./floorStatus1.svg": "52ea",
	"./floorStatus2.svg": "5fe0",
	"./goods.svg": "7421",
	"./happy.svg": "7342",
	"./haspeople.svg": "47be",
	"./home (1).svg": "3935",
	"./home.svg": "6bbe",
	"./index_no_data.svg": "7871",
	"./info.svg": "4be3",
	"./install.svg": "1e5a",
	"./invalid.svg": "5ca6",
	"./isscollop.svg": "37f0",
	"./list.svg": "3289",
	"./log.svg": "fea0",
	"./maintenance.svg": "299b",
	"./map_icon.svg": "23fd",
	"./menu (1).svg": "1b2bf",
	"./menu.svg": "bd3d",
	"./menuManage.svg": "b2ca",
	"./menu_manage.svg": "82ab",
	"./mocha_itom.svg": "3b71",
	"./monitor.svg": "cdec",
	"./network_out.svg": "2aa0",
	"./noStatisticalData.svg": "60c9",
	"./normal.svg": "babc",
	"./notImgList.svg": "f8e2",
	"./notViodeo.svg": "b820",
	"./notpeople.svg": "8722",
	"./offLine.svg": "b9c1",
	"./onLine.svg": "dd60",
	"./online_1.svg": "6c32",
	"./other.svg": "5f34",
	"./project.svg": "69e4",
	"./reportConfigure.svg": "800a",
	"./role (1).svg": "6cbd",
	"./role.svg": "520c",
	"./sendConfigure.svg": "0393",
	"./shrink.svg": "93e3",
	"./statistic.svg": "e33d",
	"./statistics.svg": "a1cf",
	"./stop.svg": "bdb7",
	"./summarize.svg": "b4cd",
	"./system_tools.svg": "e365",
	"./test.svg": "fe8d",
	"./toBottom.svg": "a0ba",
	"./toTop.svg": "c9fd",
	"./uncivilized.svg": "a7ca",
	"./updateConfigure.svg": "c689",
	"./user.svg": "b3b5",
	"./video.svg": "8f2b",
	"./warning.svg": "7e6f",
	"./wave.svg": "77a3",
	"./wechat.svg": "80da",
	"./workOrder.svg": "aadc",
	"./yes.svg": "8d65",
	"./个数.svg": "97d1",
	"./代办.svg": "cab6",
	"./关注.svg": "4e49",
	"./在线个数.svg": "9398",
	"./提醒事项.svg": "682e",
	"./收藏.svg": "1d93",
	"./故障个数.svg": "5846",
	"./检修个数.svg": "38ae",
	"./离线个数.svg": "66ec",
	"./通知个数.svg": "06ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";